import React from 'react'
import {Link} from "react-router-dom";

import "./Navbar.css";
import logo from "../images/LOGO_NEW-THSE.jpg";

function Navbar() {
  return (
    <div>
        <div className='fixed-top'>
        <div className="thehopingsunexim">
                    <div className="album py-1">
                        <div className="container">
                            <div className="row">

                                <div className="col-md-4">
                                    <div className="d-flex justify-content-between align-items-center">

                                        <a style={{ color: "white" }} className="btn-gradnav" href="tel: +91 8695269630"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-minus" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M10 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5" />
                                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
                                        </svg><small> +91 8695269630</small> </a>
                                    
                                    <a style={{ color: "white" }} href='/enquiry'> <small>Enquiry</small></a>



                                    </div>

                                </div>

                                <div className="d-flex justify-content-between align-items-center">





                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        <nav className="navbar navbar-expand-lg navbar-white bg-white shadow">
  <div className="container-fluid">
    <div className='bestexporterinnadia'>
      <div className='radius'>
        <Link to="/">
  <img src={logo} height="50px" width="143px" alt='logo'/>
  </Link>
  </div>
    </div>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
        <li className="nav-item">
        <div className='bestexporterinnadia'>
          <Link to="/" className="nav-link" aria-current="page" href="#">HOME</Link>
          </div>
        </li>
        <li className="nav-item">
        <div className='bestexporterinnadia'>
          <Link to="/about-us" className="nav-link" href="#">ABOUT US</Link>
          </div>
        </li>
        <li className="nav-item">
        <div className='bestexporterinnadia'>
          <Link to="/director" className="nav-link" href="">DIRECTOR PROFILE</Link>
          </div>
          
        </li>
        <li className="nav-item">
        <div className='bestexporterinnadia'>
          <a   className="nav-link" href="Gallery">GALLERY</a>
          </div>
          
        </li>
        
        
        <li className="nav-item dropdown">
          <a style={{color:"darkBlue"}} className="nav-link dropdown-toggle " href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            PRODUCTS
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="Basmati-rice"> BASMATI RICE </a></li>
            <li><a className="dropdown-item" href="miniket-rice"> NON POLIS MINIKET RICE </a></li>
            
            <li><a className="dropdown-item" href="dairy">DAIRY</a></li>
         
            <li><a className="dropdown-item" href="dhaniya-seed">DHANIYA (Coriander Seeds)</a></li>
            <li><a className="dropdown-item" href="Ginger">GINGER</a></li>
            <li><a className="dropdown-item" href="garments">GARMENTS</a></li>
            <li><a className="dropdown-item" href="handcraft">HANDCRAFT PRODUCTS</a></li>
            <li><a className="dropdown-item" href="cane-furniture">CANE FURNITURE</a></li>
            <li><a className="dropdown-item" href="krishnagar_famous-Matir-putul">CLAY & SCULPTURING</a></li>
            <li><a className="dropdown-item" href="sarbhja-sarpuria">SARBHAJA & SARPURIA</a></li>
            
          </ul>
        </li>
        <li className="nav-item">
        <div className='bestexporterinnadia'>
          <Link to="/contact-us" className="nav-link" href="#">CONTSCT US</Link>
          </div>
        </li>
      </ul>
    <a href='tel: 8695269630'>
        <button className="helpline" type="submit">Helpline No.</button>
        </a>
     
    </div>
  </div>
</nav>
</div>
    </div>
  )
}

export default Navbar